import { render, staticRenderFns } from "./NewToDoSidebar.vue?vue&type=template&id=4f388589&scoped=true"
import script from "./NewToDoSidebar.vue?vue&type=script&lang=js"
export * from "./NewToDoSidebar.vue?vue&type=script&lang=js"
import style0 from "./NewToDoSidebar.vue?vue&type=style&index=0&id=4f388589&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f388589",
  null
  
)

export default component.exports